var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "row" }, [
        _vm.title ? _c("h4", [_vm._v(_vm._s(_vm.title))]) : _vm._e()
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ],
          staticClass: "input-group mb-3"
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search"
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: "Buscar opcion",
              "aria-label": "Buscar opcion",
              "aria-describedby": "input-search"
            },
            domProps: { value: _vm.search },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.search = $event.target.value
              }
            }
          }),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: "Agregar nueva opción",
                    expression: "'Agregar nueva opción'"
                  }
                ],
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.addOptionNew()
                  }
                }
              },
              [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ]
        },
        [
          _c("TreeItem", {
            key: _vm.page,
            staticClass: "item",
            attrs: { "is-open-initial": true, item: _vm.filteredTree },
            scopedSlots: _vm._u([
              {
                key: "folder-description",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "div",
                      [
                        item.levelNode < _vm.childrenLevelsLimit
                          ? _c("feather-icon", {
                              attrs: { icon: "PlusIcon" },
                              on: {
                                click: function($event) {
                                  return _vm.addOptionNew(item.optionId)
                                }
                              }
                            })
                          : _vm._e(),
                        item.levelNode
                          ? _c("b-icon", {
                              staticClass: "mr-1 cursor-pointer",
                              attrs: { icon: "pencil" },
                              on: {
                                click: function($event) {
                                  return _vm.mapAndEditOption(item)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" " + _vm._s(item.name || "--") + " ")
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "item-description",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("ul", [
                      _c(
                        "li",
                        [
                          item.levelNode < _vm.childrenLevelsLimit
                            ? _c("feather-icon", {
                                attrs: { icon: "PlusIcon" },
                                on: {
                                  click: function($event) {
                                    return _vm.addOptionNew(item.optionId)
                                  }
                                }
                              })
                            : _vm._e(),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: "Ocultar opción",
                                expression: "'Ocultar opción'"
                              }
                            ],
                            staticClass: "mr-1 cursor-pointer",
                            attrs: { icon: "TrashIcon", color: "red" },
                            on: {
                              click: function($event) {
                                return _vm.mapAndDeleteOption(item)
                              }
                            }
                          }),
                          _c("b-icon", {
                            staticClass: "mr-1 cursor-pointer",
                            attrs: { icon: "pencil" },
                            on: {
                              click: function($event) {
                                return _vm.mapAndEditOption(item)
                              }
                            }
                          }),
                          _vm._v(" " + _vm._s(item.name) + " ")
                        ],
                        1
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c(
            "div",
            { staticClass: "col-12 mt-5 mb-3" },
            [
              _c("fb-paginacion", {
                attrs: { total: _vm.pagination.pages, max: 10 },
                on: { change: _vm.handlePageChange },
                model: {
                  value: _vm.page,
                  callback: function($$v) {
                    _vm.page = $$v
                  },
                  expression: "page"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.loading
        ? _c("b-spinner", {
            key: "primary",
            staticClass: "mr-1",
            attrs: { variant: "primary" }
          })
        : _vm._e(),
      _c("option-edition-modal", {
        ref: "option-modal",
        attrs: {
          "value-type-config": _vm.valueTypeConfig,
          "extra-type-render": _vm.extraTypeRender
        },
        on: { saved: _vm.savedOption }
      }),
      _c("option-migration-modal", { ref: "option-migration-modal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }